import { dropdownItemClass } from '@/components/navbar-next/'
import { isCelerityEmployee } from '@/helpers/auth-helpers'
import { useAuthContext } from '@/hooks/use-auth-context'
import { Button, Menu } from '@mantine/core'
import Link from 'next/link'
import { Icon } from '@/components/icon'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { OrganizationTypes } from '@/api/generated/model'

export function AdminButton() {
  const { organization, session } = useAuthContext()

  // The button itself only renders for admins; product alias review is further
  // restricted to manufacturer organizations (DEV-635).
  const isManufacturer =
    organization?.OrganizationType === OrganizationTypes.Manufacturer

  // Price Sync is distributor-anchored; the Celerity-email gate is the rollout
  // flag while the page takes shape (DEV-980, same gate as the page itself) —
  // drop it to go live.
  const showPriceSync =
    organization?.OrganizationType === OrganizationTypes.Distributor &&
    isCelerityEmployee(session?.user?.email)

  return (
    <Menu shadow="md" width={170} position="bottom-start">
      <Menu.Target>
        <Button
          variant="transparent"
          c="white"
          rightSection={<Icon icon={faChevronDown} size={10} />}
        >
          Administration
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          component={Link}
          href="/branches"
          className={dropdownItemClass}
        >
          Branches
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/partners"
          className={dropdownItemClass}
        >
          Partners
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/pricesheets"
          className={dropdownItemClass}
        >
          Price Sheets
        </Menu.Item>
        {showPriceSync && (
          <Menu.Item
            component={Link}
            href="/price-sync"
            className={dropdownItemClass}
          >
            Price Sync
          </Menu.Item>
        )}
        {isManufacturer && (
          <Menu.Item
            component={Link}
            href="/products"
            className={dropdownItemClass}
          >
            Products
          </Menu.Item>
        )}
        <Menu.Item component={Link} href="/users" className={dropdownItemClass}>
          Users
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
